import {
  useState,
  useContext,
  createContext,
  useRef,
  ReactNode,
  useCallback,
} from 'react';

type ShowLoadingContextProps = {
  showLoading: boolean;
  setShowLoading: (isLoading: boolean) => void;
};

const ShowLoadingContext = createContext<ShowLoadingContextProps>({
  showLoading: false,
  setShowLoading: () => {},
});

function ShowLoading(): ShowLoadingContextProps {
  const countRef = useRef(0);

  const [showLoading, setLoading] = useState(countRef.current > 0);

  const setShowLoading = useCallback((isLoading: boolean) => {
    if (isLoading) {
      countRef.current += 1;
    } else {
      countRef.current = Math.max(countRef.current - 1, 0);
    }

    setLoading(countRef.current > 0);
  }, []);

  return { showLoading, setShowLoading };
}

type ShowLoadingProviderProps = {
  children: ReactNode;
};

export function ShowLoadingProvider({ children }: ShowLoadingProviderProps) {
  const value = ShowLoading();
  return (
    <ShowLoadingContext.Provider value={value}>
      {children}
    </ShowLoadingContext.Provider>
  );
}

/**
 * 全体のローディングを表示するhook
 * 内部にカウントを持っていて、setShowLoading(true)で+1, setShowLoading(false)で-1される
 * 内部カウントが0になるとshowLoadingはfalseを返す
 * @returns
 *          showLoading ローディングダイアログの表示フラグ
 *          setShowLoading ローディングダイアログの制御カウントの加算減算関数
 */
export const useShowLoading = () => useContext(ShowLoadingContext);
